import { FIELDS_OF_STUDY } from '@src/graphql/queries/fieldOfStudy';
import { usePaginatedFetchItems } from 'pe-core-frontend';
export const useFieldsOfStudy = ({ searchText }) => {
    const { page, setPage, pageSize, setPageSize, total, items: fieldsOfStudy, loading, error, find, orderBy, orderByDir, setOrderBy, setOrderByDir, refetch, } = usePaginatedFetchItems({
        spec: { name: searchText },
        fetchQuery: FIELDS_OF_STUDY,
        dataProp: 'fieldsOfStudy',
        initialPageSize: 10,
    });
    return {
        fieldsOfStudy,
        loading,
        page,
        pageSize,
        setPage,
        setPageSize,
        error,
        total,
        find,
        orderBy,
        orderByDir,
        setOrderBy,
        setOrderByDir,
        refetch,
    };
};
